export default "__VITE_ASSET__BpD8nVIe__"